<template>
  <van-popup v-model="legendIsShow" position="bottom" :round="true" :style="{ height: '66%' }">
    <div class="legend-info-content">
      <div class="filter-title">{{ $t('shared.title.illDesc') }}</div>
      <div class="item-title sell-state-title">{{ $t('shared.title.listState') }}</div>
      <div class="sell-state">
        <div class="legend-item">
          <span class="color-block" style="background-color: #307bff;"></span>
          <span class="color-tips">{{ $t('shared.filter.yes') }}</span>
        </div>
        <div class="legend-item">
          <span class="color-block" style="background-color: #aaaaaa;"></span>
          <span class="color-tips">{{ $t('shared.filter.no') }}</span>
        </div>
      </div>
      <div class="item-title">{{ $t('shared.title.storeTag') }}</div>
      <div class="brand-state">
        <div class="legend-item">
          <span class="color-block" style="background-color: #0db00b;"></span>
          <span class="color-tips">{{ $t('shared.filter.toBeVerified') }}</span>
        </div>
        <div class="legend-item">
          <span class="color-block" style="background-color: #ee541b;"></span>
          <span class="color-tips">{{ $t('shared.filter.sVIPCore') }}</span>
        </div>
        <div class="legend-item">
          <span class="color-block" style="background-color: #dc851f;"></span>
          <span class="color-tips">{{ $t('shared.filter.vIPCore') }}</span>
        </div>
        <div class="legend-item">
          <span class="color-block" style="background-color: #aaaaaa;"></span>
          <span class="color-tips">{{ $t('shared.filter.potential') }}</span>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      globalData: 'globalData'
    })
  },
  data () {
    return {
      legendIsShow: false
    }
  }
}
</script>

<style lang="less" scoped>
.legend-info-content {
  padding: 10px 18px 20px 18px;
  font-size: 12px;
  .filter-title {
    margin: 10px 0;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
  }
  .brand-state,
  .sell-state,
  .store-icon {
    display: flex;
    flex-wrap: wrap;
    // margin-top: 10px;
  }
  .item-title {
    margin-top: 10px;
    font-size: 16px;
    font-weight: bold;
  }
  .sell-state-title {
    margin-top: 15px;
  }
  .legend-item {
    display: flex;
    align-items: center;
    width: 50%;
    margin-top: 10px;
    .legend-img {
      width: 26px;
      height: 26px;
      margin-right: 5px;
    }
    .color-block {
      width: 60px;
      height: 26px;
      margin-right: 5px;
    }
  }
  .flavor-ban {
    flex-direction: column;
    .legend-item {
      width: 100%;
    }
  }
}
</style>
